import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { IonicModule } from '@ionic/angular';
import { ProgressBarModalComponent } from './progress-bar-modal.component';
import { PieChartModule } from '../pie-chart/pie-chart.module';
import { ImagePreloadDirectiveModule } from 'src/app/directives';
import { ShareCertificateModule } from '../share-certificate/share-certificate.component.module';

@NgModule({
	declarations: [ProgressBarModalComponent],
	imports: [
		CommonModule,
		IonicModule,
		PieChartModule,
		ImagePreloadDirectiveModule,
		ShareCertificateModule,
	],
	exports: [ProgressBarModalComponent],
})
export class ProgressBarModalModule {}
